/** 代码示例（lib/samples.ts，文档 / 首页 / 控制台共用）里的示例提示词、注释与标签。代码本身不翻译。 */
const messages = {
  'prompt.town': '镜头缓缓推进，晨雾中的山间小镇',
  'prompt.portrait': '人物看向镜头微笑，背景虚化',
  'label.urlImport': 'URL 导入',
  'label.referenceAudio': '参考图 + 参考音频',
  'label.payload': '{event} 事件（节选）',
  'c.idemKey': '业务侧唯一 ID，重试时保持不变',
  'c.keepOnRetry': '重试时保持不变',
  'c.backoff': '5s 起步，逐步放宽到 30s',
  'c.upload1': '1. 申请上传',
  'c.upload2': '2. 把文件 PUT 到返回的 upload_url（带上返回的 headers）',
  'c.upload3': '3. 完成上传',
  'c.upload4': '4. 创建素材',
  'c.multipart': 'method === "single"：直接 PUT；"multipart" 时按 part_size 切片',
  'c.pollAsset': 'asset.status: "processing" → 轮询直到 "available"',
  'c.urlImport': '返回 status=uploading；拉取并落库成功后才会变为 processing / available',
  'c.rawBody': '必须使用原始请求体验签，不能先 JSON.parse 再序列化',
  'c.oldSig': '旧密钥签名',
  'c.window': '5 分钟时间窗',
  'c.rotation': '轮换密钥后 24 小时内会带两个 v1（新、旧），任一匹配即通过',
  'c.dedupeQueue': '按 {field} 去重；尽快返回 2xx，耗时处理放到队列',
  'c.dedupe': '按 {field} 去重；尽快返回 2xx',
  'c.rawBodyShort': '原始请求体',
  'c.portrait1': '发起真人认证：返回 h5_link，30 分钟内有效',
  'c.portrait2': '把 h5_link 发给素材中的本人刷脸，然后查询结果，直到 status 为 verified / failed / expired',
};

export default messages;
